import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1a9bddb0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "c-date-header1 flex align-center"
};
var _hoisted_2 = {
  key: 1,
  class: "dateSelect flex align-center mr-auto"
};
var _hoisted_3 = {
  key: 0,
  class: "label"
};
var _hoisted_4 = {
  key: 4,
  class: "daterangeSelect flex align-center",
  style: {
    "width": "100%"
  }
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "至", -1);
});
var _hoisted_6 = {
  key: 1,
  class: "mr-auto"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_select = _resolveComponent("c-date-select");
  var _component_el_date_picker = _resolveComponent("el-date-picker");
  var _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.showDate ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.type === 0 ? (_openBlock(), _createBlock(_component_c_date_select, {
    key: 0,
    class: "my-2 flex-1",
    onConfirmDate: _ctx.confirmDate
  }, null, 8, ["onConfirmDate"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_ctx.type !== 4 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1)) : _createCommentVNode("", true), _ctx.type === 1 ? (_openBlock(), _createBlock(_component_el_date_picker, {
    key: 1,
    editable: false,
    clearable: false,
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.date = $event;
    }),
    type: "week",
    format: "gggg年ww周",
    placeholder: "请选择",
    disabledDate: _ctx.disabledDateApi,
    onChange: _ctx.confirmDate
  }, null, 8, ["modelValue", "disabledDate", "onChange"])) : _createCommentVNode("", true), _ctx.type === 2 ? (_openBlock(), _createBlock(_component_el_date_picker, {
    key: 2,
    editable: false,
    clearable: false,
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.date = $event;
    }),
    type: "month",
    placeholder: "请选择",
    disabledDate: _ctx.disabledDateApi,
    onChange: _ctx.confirmDate
  }, null, 8, ["modelValue", "disabledDate", "onChange"])) : _createCommentVNode("", true), _ctx.type === 3 ? (_openBlock(), _createBlock(_component_el_date_picker, {
    key: 3,
    editable: false,
    clearable: false,
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.date = $event;
    }),
    type: "year",
    placeholder: "请选择",
    disabledDate: _ctx.disabledDateApi,
    onChange: _ctx.confirmDate
  }, null, 8, ["modelValue", "disabledDate", "onChange"])) : _createCommentVNode("", true), _ctx.type === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_date_picker, {
    editable: false,
    clearable: false,
    modelValue: _ctx.times[0],
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.times[0] = $event;
    }),
    type: "date",
    format: "YYYY/MM/DD",
    placeholder: "请选择",
    disabledDate: _ctx.disabledTimesBeforeApi,
    onChange: _ctx.confirmDate
  }, null, 8, ["modelValue", "disabledDate", "onChange"]), _hoisted_5, _createVNode(_component_el_date_picker, {
    editable: false,
    clearable: false,
    modelValue: _ctx.times[1],
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.times[1] = $event;
    }),
    type: "date",
    format: "YYYY/MM/DD",
    placeholder: "请选择",
    disabledDate: _ctx.disabledTimesEndApi,
    onChange: _ctx.confirmDate
  }, null, 8, ["modelValue", "disabledDate", "onChange"])])) : _createCommentVNode("", true)]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_6)), _ctx.type < 3 && _ctx.showBtn || _ctx.forceShow ? (_openBlock(), _createBlock(_component_van_button, {
    key: 2,
    type: "primary",
    size: "small",
    onClick: _ctx.switchBtnClick
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.btnText), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]);
}